import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "iconStart", "iconEnd", "clearIcon", "iconClickStart", "iconClickEnd", "clearIconClick", "size", "className", "style", "fullWidth", "readOnly", "background", "focusOnMount", "focusOnClick", "error"];
import React, { useRef, useEffect } from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { InputBackgroundColor, InputSize } from '../../utils/types';
import Styled from './input.styles';

var getIconSize = function getIconSize(sizeName) {
  switch (sizeName) {
    case InputSize.Md:
      return 16;

    case InputSize.Sm:
    default:
      return 14;
  }
};

var Input = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
      iconStart = _ref.iconStart,
      iconEnd = _ref.iconEnd,
      clearIcon = _ref.clearIcon,
      iconClickStart = _ref.iconClickStart,
      iconClickEnd = _ref.iconClickEnd,
      clearIconClick = _ref.clearIconClick,
      size = _ref.size,
      className = _ref.className,
      style = _ref.style,
      fullWidth = _ref.fullWidth,
      readOnly = _ref.readOnly,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'primary' : _ref$background,
      _ref$focusOnMount = _ref.focusOnMount,
      focusOnMount = _ref$focusOnMount === void 0 ? false : _ref$focusOnMount,
      _ref$focusOnClick = _ref.focusOnClick,
      focusOnClick = _ref$focusOnClick === void 0 ? true : _ref$focusOnClick,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, _excluded);

  var inputRef = useRef(null);
  var placeholder = rest.value ? '' : rest.placeholder;

  var handleFocus = function handleFocus() {
    var _inputRef$current;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };

  useEffect(function () {
    if (focusOnMount) {
      handleFocus();
    }
  }, []);

  var handleIconClick = function handleIconClick(event, type) {
    if (focusOnClick) {
      handleFocus();
    }

    if (type === 'start') {
      if (iconClickStart) {
        iconClickStart();
      }
    } else if (type === 'end') {
      if (iconClickEnd) {
        iconClickEnd();
      }
    } else if (clearIconClick) {
      clearIconClick(event);
    }
  };

  var renderIcon = function renderIcon(_icon, type) {
    return _icon ? /*#__PURE__*/React.createElement(Styled.Icon, {
      onClick: function onClick(event) {
        return handleIconClick(event, type);
      },
      iconClickStart: iconClickStart,
      iconClickEnd: iconClickEnd,
      clearIconClick: clearIconClick
    }, typeof _icon === 'function' ? _icon({
      size: getIconSize(size)
    }) : _icon) : undefined;
  };

  var renderField = function renderField() {
    return (
      /*#__PURE__*/
      // TODO: refactor how implement tags in input
      // return renderTags ? (
      //   <Styled.Container>
      //     <Styled.Tags>{renderTags}</Styled.Tags>
      //     <Styled.Base
      //       {...rest}
      //       placeholder={placeholder}
      //       ref={inputRef}
      //       renderTags={renderTags}
      //       readOnly={Boolean(readOnly)}
      //     />
      //   </Styled.Container>
      // ) : (
      React.createElement(Styled.Base, _extends({}, rest, {
        placeholder: placeholder,
        ref: inputRef,
        readOnly: Boolean(readOnly)
      })) // );

    );
  };

  return /*#__PURE__*/React.createElement(Styled.Input, {
    onClick: focusOnClick ? handleFocus : undefined,
    ref: ref,
    size: size,
    className: className,
    style: style,
    fullWidth: Boolean(fullWidth),
    background: background,
    error: error
  }, renderIcon(iconStart, 'start'), renderField(), renderIcon(clearIcon, 'secondEnd'), renderIcon(iconEnd, 'end'), children && /*#__PURE__*/React.createElement(React.Fragment, null, children));
});
export var defaultProps = {
  size: InputSize.Md,
  background: InputBackgroundColor.Primary,
  error: false,
  fullWidth: false,
  readOnly: false
};
Input.defaultProps = defaultProps;
export var propTypes = {
  size: PT.oneOf(objectValues(InputSize)),
  iconStart: PT.oneOfType([PT.node, PT.func]),
  iconEnd: PT.oneOfType([PT.node, PT.func]),
  clearIcon: PT.node,
  error: PT.bool,
  fullWidth: PT.bool,
  value: PT.any,
  readOnly: PT.bool,
  iconClickStart: PT.func,
  iconClickEnd: PT.func,
  clearIconClick: PT.func,
  background: PT.oneOf(objectValues(InputBackgroundColor)),
  focusOnMount: PT.bool,
  focusOnClick: PT.bool /// / TODO: refactor how implement tags in input
  // renderTags: PT.node,

};
Input.propTypes = propTypes;
export default Input;